import React from "react";
import MapSvg from "../map/MapSvg";
import BuySelectedPlots from "../footer/BuySelectedPlots";

const Home = ({  Events }) => {
    return (
        <>
            <MapSvg Events={Events} />
            <BuySelectedPlots  />
        </>
    )
}

export default Home;